export const LOGIN = "/auth/login";
export const FORGET_PASSWORD = "/auth/forgot-password";
export const RESET_PASSWORD = "/auth/reset-password";
export const PROFILE = "/auth/profile";
export const PASS_CHANGE = "/auth/change-password";
export const DISTRIBUTOR = "/distributor";
export const ADMIN = "/admin-users";
